import { useEffect } from 'react';
import { Button } from 'antd';
import { useMsal } from '@azure/msal-react';
import { useIsAuthenticated } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { loginRequest } from '../../settings/azure/authConfig';

import { LoginContainer, LoginButtonContainer, LoginTitle, LoginDescription } from './style';

export const Login = () => {
  const { t } = useTranslation();
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/front');
    }
  }, [navigate, isAuthenticated]);

  const handleLogin = async () => {
    const authData = await instance.loginPopup(loginRequest);

    if (authData) {
      localStorage.setItem('token', authData.accessToken);
    }

    // TODO: error handler
  };

  return (
    <LoginContainer>
      <LoginButtonContainer>
        <LoginTitle>{t('login.login')}</LoginTitle>
        <LoginDescription>{t('login.loginDescription')}</LoginDescription>
        <Button type='primary' onClick={handleLogin}>
          {t('login.loginAzureAD')}
        </Button>
      </LoginButtonContainer>
    </LoginContainer>
  );
};
